export const samlTokenHandler = {
  failure: {
    cta: 'Okay',
    description:
      'Please try again or contact support if you continue to have issues.',
    title: 'Your SSO token is invalid.',
  },
};
